export default __webpack_public_path__ + "static/media/icons8-figma.44ca2c32.svg";